export default __webpack_public_path__ + "static/media/information--dead-end-except-bicycles--g1.00a6125f.png";